import axios from 'axios'
import {alertFun} from "../components/alert";
import {
	Loading,
	Message,
	MessageBox
} from "element-ui";
import store from '@/store'

// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_BASE_URL)

/* if(process.env.NODE_ENV == "development"){
	//开发环境
}else if(process.env.NODE_ENV == "test"){
	//测试环境
}else{
	//生产环境
} */
let baseURL = process.env.VUE_APP_BASE_URL
console.log(baseURL);

const service = axios.create({
	baseURL: baseURL,
	timeout: 50000, // 请求超时时间
})

let loadingInstance;
service.interceptors.request.use(
	config => {
		if (config.isLoading == undefined || config.isLoading) {
			loadingInstance = Loading.service({
				text: config.loadingMsg ? config.loadingMsg : "正在加载...",
				spinner: 'el-icon-loading',
				background: "rgba(0, 0, 0, 0.3)"
			});
		}
		if (store.getters.token) {
			config.headers['authorization'] = store.getters.token;
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
// response 拦截器
service.interceptors.response.use(
	response => {
		if (loadingInstance) loadingInstance.close();
		// 验证码、文件下载
		if (response.headers['content-type'] === 'application/octet-stream') {
			return response
		}
		const res = response.data;
		if (res.status === 1) {
			return res;
		} else {
			if (res.status === 50008 || res.status === 50014) {
				alertFun({title: '登录失效',message:'登录信息过期，请重新登录',content: '可能原因<br/>长时间未进行操作，或账号在其他设备登录<br/>若怀疑账号被他人登录，请及时修改密码'}).then(()=>{
					store.dispatch('user/resetToken').then(() => {
						location.reload()
					})
				})
				return false
				// MessageBox.alert("登录失效，请重新登录", "登录失效").then(() => {
				// 	store.dispatch('user/resetToken').then(() => {
				// 		location.reload()
				// 	})
				// })
			}
			Message({
				message: res.message || 'Error',
				type: "error",
				duration: 3000
			});
			return Promise.reject(new Error(res.message || 'Error'))
		}
	},
	error => {
		if (loadingInstance) loadingInstance.close();
		if (error && error.response) {
			switch (error.response.status) {
				case 400:
					error.message = '错误请求';
					break;
				case 401:
					error.message = '未授权，请重新登录';
					break;
				case 403:
					error.message = '拒绝访问';
					break;
				case 404:
					error.message = '请求错误,未找到该资源';
					break;
				case 405:
					error.message = '请求方法未允许';
					break;
				case 408:
					error.message = '请求超时';
					break;
				case 500:
					error.message = '服务器端出现错误';
					break;
				case 501:
					error.message = '网络未实现';
					break;
				case 502:
					error.message = '网络错误';
					break;
				case 503:
					error.message = '服务不可用';
					break;
				case 504:
					error.message = '网络超时';
					break;
				case 505:
					error.message = 'http版本不支持该请求';
					break;
				default:
					error.message = `未知错误${error.response.status}`;
			}
		} else {
			error.message = "连接到服务器失败";
		}
		Message({
			message: error.message,
			type: "error",
			duration: 3000
		});
		return Promise.reject(error);
	}
)
export default service
